/**
 * True when the visitor's country uses English on Pupvote (today US, CA,
 * GB, IE, AU and NZ, per each country's `language` from the API).
 *
 * The photobook entry quiz and the shop are English-only, so the promo
 * banner is limited to these countries. An unknown country (still loading,
 * or none) counts as not English, so the banner never flashes up for
 * someone it would then disappear on.
 */
export default function isEnglishCountry(country) {
  return Boolean(country && country.language === 'en');
}
